import React, { useState } from "react";
import { Box, Checkbox, Dialog, IconButton, InputBase, InputLabel, MenuItem, Paper, Select, Typography } from "@mui/material";
import { StudioCategoriesTable } from 'src/components/StudioCategoriesTable';
import { CheckIcon, CloseIcon, SearchIcon, WorkingTimeSidebarInfoIcon } from "src/Icons";

import { SubmitButton } from "../Button/SubmitButton";
import { MidCategoryCard } from "../Dialogs/StudioDialog/ServiceAndCategoryStep.tsx/SimplifiedCategoryCard";

export enum SortTypes {
  NAME = 'Name',
  SIZE = 'Size',
}

interface AssignModalProps {
    openedFrom: 'sidebar' | 'prewiev' | '';
    isOpen: boolean;
    categories: any;
    assignedCategories: any;
    onClose: () => void;
    onSubmit: () => void;
    onSelect?: (value: any) => void;
  }

export const AssignModal = ({
  openedFrom,
  isOpen,
  categories,
  assignedCategories,
  onClose,
  onSubmit,
  onSelect,
}: AssignModalProps) => {

  const [searchInput, setSearchInput] = useState<string>('');

  const checkSelection = (id: number) => {
    return assignedCategories.map((cat: any) => +cat.id).includes(id)
  }

  const handleSubmit = () => {
    onSubmit();
    onClose();
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: "16px",
          width: openedFrom === 'sidebar' ? "984px" : "1200px",
          maxWidth: openedFrom === 'sidebar' ? "984px" : "1200px",
          maxHeight: "730px",
        },
      }}
    >
      <Box
        sx={{
          padding: "32px",
          borderRadius: "16px",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "#B9B9B9",
              marginBottom: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#080808",
                  marginRight: "8px",
                }}
              >
                {openedFrom === 'sidebar' ? "Choose Categories" : "Attached services preview"}
              </Typography>
              <WorkingTimeSidebarInfoIcon fontSize="inherit" />
            </Box>

            <Box
              onClick={onClose}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "28px",
                fontSize: "24px",
                cursor: "pointer",

                "&:hover": {
                  color: "#828282",
                },
              }}
            >
              <CloseIcon fontSize="inherit" />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
            }}
          >
            {/* SEARCH */}
            <Box
              sx={{
                display: "flex",
                flex: 1,
                padding: "16px 0",
              }}
            >
              <Box
                display="flex"
                sx={{
                  border: "1px solid #D6D6DB",
                  backgroundColor: "#FAFAFA",
                  borderRadius: '8px',
                  flex: 1,
                  maxWidth: "312px",
                }}
              >
                <InputBase
                  sx={{ ml: 2, flex: 1, fontSize: "14px", }}
                  placeholder="Search"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <IconButton type="button" onClick={() => {}}>
                  <SearchIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>

          {openedFrom === 'sidebar' ?
            <>
              <Paper
                sx={{
                  elevation: 4,
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginTop: '18px',
                  marginBottom: '36px',
                  minHeight: '112px',
                  minWidth: '920px',
                  paddingBottom: '24px',
                  borderRadius: '6px',
                  boxShadow: 'rgb(0, 0, 0, 0.05) 5px 5px 5px 5px',
                }}
              >
                {categories.map((category: any) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      margin: '24px 0px 0px 24px',
                    }}
                  >
                    <Checkbox
                      checked={checkSelection(+category.id)}
                      onChange={() => onSelect && onSelect(category)}
                      icon={<></>}
                      checkedIcon={<CheckIcon fontSize="inherit" />}
                      sx={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "6px",
                        border: "1px solid #667085",
                        fontSize: "16px",

                        "&:hover": {
                          backgroundColor: "#FFF8FA",
                          boxShadow: "#FFF2F7 0px 0px 0px 4px",
                        },

                        "&.Mui-checked": {
                          backgroundColor: "#FFF8FA",
                          borderColor: "#BF295C",
                          color: "#F56193",
                        },

                        "& .MuiSvgIcon-root": {
                          position: "relative",
                          top: "-1px",
                        },
                      }}
                      disableRipple
                    />
                    <MidCategoryCard
                      isSelected={checkSelection(+category.id)}
                      category={category}
                      onClick={onSelect || (() => {})}
                    />
                  </Box>
                ))}
              </Paper>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{fontSize: '14px'}}>
                  <span>You chose</span>
                  <span style={{ color: '#BF295C', fontWeight: '600'}}>
                    {` ${assignedCategories.length} ${assignedCategories.length === 1 ? 'category' : 'categories'} `}
                  </span>
                  <span>for this studio</span>
                </Typography>

                <SubmitButton
                  sx={{ minHeight: '48px', }}
                  title="Confirm selection"
                  onClick={handleSubmit}
                />
              </Box>
            </>
            :
            <Paper
              sx={{
                elevation: 4,
                display: 'flex',
                flexWrap: 'wrap',
                marginTop: '18px',
                minHeight: '526px',
                minWidth: '900px',
                paddingBottom: '24px',
                borderRadius: '6px',
                boxShadow: 'rgb(0, 0, 0, 0.05) 5px 5px 5px 5px',
              }}
            >
              <Box sx={{
                overflow: 'auto',
              }}>

                <StudioCategoriesTable
                  withoutFilterSection
                  withoutEditing
                  studioCategories={categories}
                />
              </Box>
            </Paper>
          }
        </Box>
      </Box>
    </Dialog>
  );
}
